export const AUTOSAVE_DEBOUNCE_TIME = 1_000;
